export default __webpack_public_path__ + "static/media/portal2_room.3ca5de96.png";